import React from "react";
import ModalInfo from "../../ModalInfo";

import { Accordion, Card } from "react-bootstrap";

class Page8 extends React.Component {
  state = {
    visible: true,
    modalShow: true,
    instructions: (
      <div>
        <p>
          Now that you have created a shopping list of what motivates you and
          what your strengths are. The next step is to generate possible career
          options. In this activity we are presenting you with 10
          option-generating ideas. Have a go at one or two ideas in your own
          time and consider the questions on the next page.
        </p>
      </div>
    ),
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 8) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">
                    10 Ways To Generate Career Options
                  </h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() => this.setState({ modalShow: true })}
                  ></i>
                </div>
              </ul>
            </nav>
            <br />
            <br />

            <div className="container">
              <div id="moduleContentText_2">
                <div
                  className="card mb-4 box-shadow h-100"
                  id="pageContent_2"
                  style={{ cursor: "pointer", textAlign: "left" }}
                >
                  <Accordion defaultActiveKey="0">
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="0">
                        1.Degree
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          The{" "}
                          <a
                            target="_blank"
                            href="https://www.prospects.ac.uk/careers-advice/what-can-i-do-with-my-degree"
                          >
                            Prospects Options series
                          </a>{" "}
                          lists a number of common career options for a range of
                          degree subjects. Here you can explore a wide range of
                          careers and consider them in the context of your
                          values and strengths.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="1">
                        2.Destinations
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="1">
                        <Card.Body>
                          Find out what{" "}
                          <a
                            target="_blank"
                            href="https://www.prospects.ac.uk/careers-advice/what-can-i-do-with-my-degree"
                          >
                            recent graduates
                          </a>{" "}
                          from your subject have gone on to do 6 months after
                          graduating. You can also find out what{" "}
                          <a
                            target="_blank"
                            href="https://www.bath.ac.uk/guides/what-do-first-degree-bath-graduates-do/"
                          >
                            Bath Graduates
                          </a>{" "}
                          have done.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="2">
                        3.Careers matching tools
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="2">
                        <Card.Body>
                          Prospects Career Planner - An online careers{" "}
                          <a
                            target="_blank"
                            href="https://www.prospects.ac.uk/planner"
                          >
                            matching programme
                          </a>{" "}
                          that will suggest relevant careers based on your
                          skills, interests and values.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="3">
                        4.Attend careers events
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="3">
                        <Card.Body>
                          You will have the opportunity to attend a wide range
                          of
                          <a
                            target="_blank"
                            href="https://unihub.bath.ac.uk/students/login?ReturnUrl=%2fs%2fmyfuture%2fevents"
                          >
                            {" "}
                            careers events
                          </a>{" "}
                          as a student.
                          <br />
                          Raise your awareness of opportunities by attending
                          careers fairs, employer presentations (both on campus
                          and in-house). Find career conferences and networking
                          events relating to sectors you’re interested in and
                          learn as much as you can about the range of job roles
                          attendees are involved in.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="4">
                        5.Societies and institutes
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="4">
                        <Card.Body>
                          Organisations linked to particular subjects have
                          careers sections on their website (e.g. Institute of
                          Physics or Royal Geographical Society) including case
                          studies and testimonials from industry professionals.
                          They may offer conferences or mentoring opportunities
                          to allow you to meet and learn from industry
                          professionals.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="5">
                        6.Focus on a subject
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="5">
                        <Card.Body>
                          Choose a topic that really interests you e.g.
                          technology. Use a search engine to find out all the
                          jobs you can that involve doing it, helping others to
                          do it, teaching or talking about it, selling it,
                          writing about it, creating products related to it,
                          organising events associated with it, promoting it -
                          enlist others to help you
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="6">
                        7.Use those around you
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="6">
                        <Card.Body>
                          Make a list of everyone you know: family, friends, and
                          colleagues. Ask them what they think your skills and
                          strengths are (and what they could see you doing). Ask
                          them why? Ask them if they know anyone who is doing
                          that job already. Talk to that person and ask them
                          what other jobs they could see themselves doing.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="7">
                        8.Focus on strengths
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="7">
                        <Card.Body>
                          Choose a particular strength that you enjoy using
                          (writing, problem solving, negotiating, public
                          speaking, analysing information, organising etc). Now
                          generate all the jobs that you can think of that use
                          that talent – use search engine searches such as
                          ‘career using X strengths’. Ask other people for their
                          ideas. It is often helpful to research as many
                          different words for your strength as you can (use an
                          online thesaurus). For example advising could also be
                          counselling, supporting, guiding, informing, directing
                          etc. The more words you have, the more ideas you might
                          prompt.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="8">
                        9.Video testimonies
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="8">
                        <Card.Body>
                          Seek out{" "}
                          <a target="_blank" href="https://icould.com/">
                            testimonies provided by staff from a wide range of
                            different professions
                          </a>
                          . These testimonies are categorised by degree subject,
                          sector or job role.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="9">
                        10.Use social media
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="9">
                        <Card.Body>
                          Join discussion groups relating to{" "}
                          <a target="_blank" href="https://www.linkedin.com/">
                            interesting subjects or sectors on LinkedIn
                          </a>
                          . Look at the profiles of contributors and see what
                          job roles they have now and how they got there.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              </div>
            </div>
            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title="INSTRUCTIONS"
              content={this.state.instructions}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page8;
